/**
 * TrackLicenseBuilderButton Component
 */

import { licenseUsagesToSearchParams } from '../../../../redux/helpers/license';

import * as React from 'react';

import { TrackLicensingContext } from '../../../../contexts/trackLicensing';
import { ITrackLicensingContext } from '../../../../contexts/trackLicensing/types';
import LicenseBuilderButton from './index';
import SessionLicenseBuilderButton, { ExposedSessionLicenseBuilderButtonProps } from './SessionLicenseBuilderButton';

interface IOwnProps {
  scope?: ITermsScope;
  track: string;
}

interface TrackLicenseBuilderButtonProps extends IOwnProps, ExposedSessionLicenseBuilderButtonProps {
  licensingContext: ITrackLicensingContext;
}

export type ExposedTrackLicenseBuilderButtonProps = IOwnProps & ExposedSessionLicenseBuilderButtonProps;

class TrackLicenseBuilderButton extends React.Component<TrackLicenseBuilderButtonProps> {

  shouldComponentUpdate() {
    return false;
  }

  onClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    this.props.licensingContext.setTrack(this.props.track);

    if (!!this.props.onClick) {
      e.persist();
      this.props.onClick(e);
    }
  }

  onSaveLicense = (usages: ILicenseUsage[]) => {
    if (usages.length === 0) {
      this.props.licensingContext.clearAll();
    } else {
      this.props.licensingContext.setUsages(licenseUsagesToSearchParams(usages));
    }

    if (!!this.props.onSaveLicense) {
      this.props.onSaveLicense(usages);
    }
  }

  render() {
    const {
      licensingContext: unusedTrackLicensingContext,
      onClick: unusedOnClick,
      onSaveLicense: unusedOnSaveLicense,
      scope,
      track: unusedTrack,
      ...buttonProps
    } = this.props;

    return !!scope && scope.type !== 'Session' ? (
      <LicenseBuilderButton
        onClick={this.onClick}
        onSaveLicense={this.onSaveLicense}
        scope={scope}
        {...buttonProps}
      />
    ) : (
      <SessionLicenseBuilderButton
        onClick={this.onClick}
        onSaveLicense={this.onSaveLicense}
        {...buttonProps}
      />
    );
  }
}

const TrackLicenseBuilderButtonWithContexts: React.SFC<IOwnProps & ExposedSessionLicenseBuilderButtonProps> =
  (props) => {
    return (
      <TrackLicensingContext.Consumer>
        {(ctx) => (
          <TrackLicenseBuilderButton
            licensingContext={ctx}
            {...props}
          />
        )}
      </TrackLicensingContext.Consumer>
    );
  };

export default TrackLicenseBuilderButtonWithContexts;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LicenseBuilderButton/TrackLicenseBuilderButton.tsx